<template>
  <div class="rounded-xl p-5 bg-gray-800 border border-gray-700 overflow-hidden">
    <slot />
  </div>
</template>

<script setup lang="ts">

</script>
